import { type AnalyticsState, initialAnalyticsState } from "./analytics/AnalyticsState";
import { type ConfigState, initialConfigState } from "./config/ConfigState";
import { type EntitiesState, initialEntitiesState } from "./entities/EntitiesState";
import { type LayoutState, initialLayoutState } from "./layout/LayoutState";
import { type PagesState, initialPagesState } from "./pages/PagesState";
import { type LocationState, initialLocationState } from "./route/RouteReducer";
import { type UsageTrackState, initialUsageTrackState } from "./usage-track/UsageTrackState";
import { type VisualizerState, initialVisualizerState } from "./visualizer/VisualizerState";

export interface RootState {
	analytics: AnalyticsState;
	config: ConfigState;
	layout: LayoutState;
	usageTrack: UsageTrackState;
	entities: EntitiesState;
	pages: PagesState;
	location: LocationState;
	visualizer: VisualizerState;
}

export const initialRootState: RootState = {
	analytics: initialAnalyticsState,
	config: initialConfigState,
	layout: initialLayoutState,
	usageTrack: initialUsageTrackState,
	entities: initialEntitiesState,
	pages: initialPagesState,
	location: initialLocationState,
	visualizer: initialVisualizerState,
};
